export default "__VITE_ASSET__92037dbb__"